import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Footer } from '../index';
import usePerformanceMonitor from '../../hooks/usePerformanceMonitor';

// Import components directly instead of lazy loading
import Hero from '../features/Hero';
import Services from '../features/Services';
import Portfolio from '../features/Portfolio';
import Reviews from '../features/Reviews';
import About from '../features/About';
import Contact from '../forms/Contact';


const HomePage = () => {
  // Monitor performance metrics
  const performanceMetrics = usePerformanceMonitor();

  return (
    <>
      <Helmet>
        <title>RC Roofing - Professional Roofing, Windows, Siding, Gutters & Repairs</title>
        <meta name="description" content="RC Roofing - Top-rated roofing contractors specializing in roofing, windows, siding, gutters, and repairs. 12+ years experience, 400+ completed projects. Licensed & insured. Free estimates available." />
        <meta name="keywords" content="roofing services, window installation, siding installation, gutter repair, roof repairs, residential roofing, commercial roofing, gutter cleaning, siding repair, roofing contractor, licensed roofer, roof replacement, gutter installation" />
        <link rel="canonical" href="https://rcroofing.com/" />
        
        {/* Open Graph */}
        <meta property="og:title" content="RC Roofing - Professional Roofing, Windows, Siding, Gutters & Repair Services" />
        <meta property="og:description" content="Top-rated roofing contractors with 12+ years experience. Roofing, windows, siding, gutters, and repairs. Licensed & insured. Free estimates." />
        <meta property="og:url" content="https://rcroofing.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://rcroofing.com/images/banner/hero1.webp" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="RC Roofing - Professional Roofing Services" />
        <meta name="twitter:description" content="Top-rated roofing contractors with 12+ years experience. Licensed & insured. Free estimates." />
        <meta name="twitter:image" content="https://rcroofing.com/images/banner/hero1.webp" />
      </Helmet>
      <main id="main-content">
        <Hero />
        <Services />
        <Portfolio />
        <Reviews />
        <About />
        <Contact />
        <Footer />
      </main>
    </>
  );
};

export default HomePage;
